import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/auth/auth.service';
import { ToastService } from '@teorema/patron';
import { FilterField, FilterOperator, Ticket, TicketRevision, User } from 'src/app/models';
import { utils } from 'src/app/shared';
import { TcTicketRevisionService } from 'src/app/shared/services';

@Component({
  selector: 'revisions-tab',
  templateUrl: './revisions-tab.component.html',
  styles: [],
  standalone: false,
})
export class RevisionsTabComponent implements OnInit {
  @Input() unconfirmedTicket?: Ticket;
  @Input() user?: User;

  visibleModalDelete = false;

  deleteMessageModal?: string;

  ticketRevision?: TicketRevision;
  loading: boolean = false;
  dateString?: string;

  revisions?: TicketRevision[];
  deleteIndex = -1;
  editIndex = -1;
  formRevisionTicket!: FormGroup;

  constructor(
    private authService: AuthService,
    private toastr: ToastService,
    private formBuilder: FormBuilder,
    private ticketRevisionService: TcTicketRevisionService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {
    this.formRevisionTicket = this.formBuilder.group({
      idCommit: [null, Validators.required],
      dateStringTicket: ['', Validators.required],
      version: [null],
      observationTicket: [null],
    });
    this.clearTicketRevision();
  }
  ngOnInit(): void {}

  async saveRevision() {
    if (!this.revisions) {
      this.revisions = [];
    }

    if (!this.formRevisionTicket.get('idCommit')?.value) {
      this.toastr.show({ color: 'error', message: 'ID Commit não informado' });
      return;
    }

    this.ticketRevision!.id_commit = this.formRevisionTicket.get('idCommit')?.value;

    if (
      this.editIndex == -1 &&
      this.revisions.find(tr => tr.id_commit == this.ticketRevision!.id_commit)
    ) {
      this.toastr.show({ color: 'error', message: 'Esse ID Commit já foi adicionado ao chamado' });
      return;
    }

    this.ticketRevision!.user = this.user;
    this.ticketRevision!.ticket = {
      id: this.unconfirmedTicket!.id,
    } as Ticket;

    this.ticketRevision!.observation = this.formRevisionTicket.get('observationTicket')?.value;
    this.ticketRevision!.version = this.formRevisionTicket.get('version')?.value;
    this.ticketRevision!.date = this.formRevisionTicket.get('dateStringTicket')?.value;

    this.loading = true;

    if (this.editIndex > -1) {
      this.editRevision(this.ticketRevision!);
    } else {
      let response = await this.ticketRevisionService
        .save(this.ticketRevision!)
        .catch(() => {
          this.toastr.show({
            color: 'error',
            message: 'Houve um erro ao salvar',
          });
        })
        .finally(() => {
          this.loading = false;
        });

      if (response?.id) {
        this.toastr.show({
          color: 'success',
          message: 'ID Commit salvo com sucesso!',
        });

        this.revisions.unshift(response);
        this.clearTicketRevision();
        this.cdr.markForCheck();
      }
    }
  }

  async editRevision(ticketRevision: TicketRevision) {
    let response = await this.ticketRevisionService
      .patch(this.revisions![this.editIndex].id, ticketRevision)
      .catch(() => {
        this.toastr.show({
          color: 'error',
          message: 'Houve um erro ao salvar',
        });
      })
      .finally(() => {
        this.loading = false;
      });

    if (response?.id) {
      this.revisions![this.editIndex] = response;
      this.toastr.show({
        color: 'success',
        message: 'ID Commit editado com sucesso!',
      });
      this.clearTicketRevision();
      this.cdr.markForCheck();
    }
  }

  clearTicketRevision() {
    this.editIndex = -1;
    this.ticketRevision = new TicketRevision();
    this.formRevisionTicket
      ?.get('dateStringTicket')
      ?.setValue(utils.dateToDateInputStr(new Date()));
    this.formRevisionTicket?.get('idCommit')?.setValue(null);
    this.formRevisionTicket?.get('observationTicket')?.setValue(null);
    this.formRevisionTicket?.get('version')?.setValue(null);
  }

  cancelEdit() {
    this.clearTicketRevision();
  }

  edit(index) {
    this.editIndex = index;
    this.formRevisionTicket.get('idCommit')?.setValue(this.revisions![this.editIndex].id_commit);
    this.formRevisionTicket
      .get('observationTicket')
      ?.setValue(this.revisions![this.editIndex].observation);
    this.formRevisionTicket.get('version')?.setValue(this.revisions![this.editIndex].version);
    this.formRevisionTicket.get('dateStringTicket')?.setValue(this.revisions![this.editIndex].date);
  }

  openDeleteConfirmationModal(index) {
    this.deleteIndex = index;
    this.deleteMessageModal = `Tem certeza de que deseja remover o requisito "${this.revisions![this.deleteIndex].id_commit}" do chamado?`;

    this.visibleModalDelete = true;
  }

  async delete() {
    this.loading = true;
    let response = await this.ticketRevisionService
      .delete(this.revisions![this.deleteIndex].id)
      .catch(() => {
        this.toastr.show({
          color: 'error',
          message: 'Houve um erro ao deletar',
        });
      })
      .finally(() => {
        this.loading = false;
      });

    if (response === true) {
      this.toastr.show({
        color: 'success',
        message: 'ID Commit removido com sucesso',
      });
      this.revisions!.splice(this.deleteIndex, 1);
      this.deleteIndex = -1;
      this.visibleModalDelete = false;
      this.cdr.markForCheck();
    }
  }

  cancelModal() {
    this.visibleModalDelete = false;
    this.deleteIndex = -1;
  }

  async loadTicketRevision() {
    this.revisions = [];
    let promisse: any = null;
    promisse = this.ticketRevisionService.findAll({
      filters: [
        new FilterField({
          name: 'equal[ticket_id]',
          value: this.unconfirmedTicket?.id,
          operator: FilterOperator.has,
          label: '',
        }),
      ],
    });

    let response = await promisse.catch(e => {
      console.error(e);
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });

    if (response?.data?.length) {
      this.revisions = response.data;
      this.cdr.markForCheck();
    }
  }

  isDevCanWrite() {
    return utils.checkAccess(['Development'], true, true).result;
  }
}
